module.exports = __webpack_public_path__ + "static/media/cq_grafico_torta b.71856c63.svg";